import testProgressApi from "../../api/dte/testProgressApi";

const TestProgressService = {

  getProgress: async () => {
    try {
      // GET /dte/test-progress
      const response = await testProgressApi.fetchAll();
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getCompleted: async () => {
    try {
      const response = await testProgressApi.fetchCustom("/completed");
      return response.data;
    } catch (error) {
      throw error;
    }
  },


};

export default TestProgressService;
